<template>
    <div class="o-input-text">
        <textarea
            v-if="type == 'textarea'"
            :id="_uid"
            :name="name"
            :required="required"
            v-model="value"
            class="o-input-text__input o-input-text__input--textarea"
            :class="{ 'is-filled' : isFilled }"
        ></textarea>
        <input
            v-else
            :id="_uid"
            :name="name"
            :required="required"
            :type="type"
            v-model="value"
            class="o-input-text__input"
            :class="{ 'is-filled' : isFilled }"
        >
        <label
            :for="_uid"
            class="o-input-text__label"
        >
            {{ placeholder }}
            <span v-if="required">*</span>
        </label>
    </div>
</template>

<script>/* eslint-disable */

    export default {
        name: 'InputText',
        props: {
            placeholder: {
                type: String,
                required: true
            },
            type: {
                type: String,
                default: 'text'
            },
            name: {
                type: String,
                required: true
            },
            required: {
                type: Boolean,
                default: false
            }
        },
        data: () => {
            return {
                value: ''
            }
        },
        computed: {
            isFilled() {
                return this.value !== ''
            }
        }
    }
</script>

<style lang="scss" scoped>

    .o-input-text {
        font-size: .9em;
        color: $color-primary-light;
    }

    .o-input-text__input {
        display: block;
        padding: .8em 1em;
        width: 100%;
        border: $border-light;
        border-radius: $radius;

        &--textarea {
            height: 10em;
            resize: none;
        }

        &.has-error {
            border-color: red;
        }

        &:focus,
        &.is-filled {

            & + .o-input-text__label {
                transform: translate(-.25em, -1.25em) scale(.8);
                transition: transform .2s $out-quad;
            }
        }
    }

    .o-input-text__label {
        position: absolute;
        top: .8em;
        left: calc(1em - .5em);
        display: inline-block;
        padding-right: .5em;
        padding-left: .5em;
        background-color: $color-light;
        border-radius: $radius;
        transform-origin: 0 0;
        transition: transform .2s ease-out;
    }

</style>
